export enum RoomType {
    ROOM = 'ROOM',
    WAITING_ROOM = 'WAITING_ROOM',
    UNKNOWN = 'Unknown',
}

export interface Room {
    instance_id?: string;
    room_id: string;
    room_name: string;
    room_type: RoomType;
}
